import { lazy } from 'react';
export const NewConversation = lazy(() => import('./NewConversation/NewConversation').then(c => ({
    default: c.NewConversation,
})));
export const ProgressTimelineItem = lazy(() => import('./ProgressTimelineItem/ProgressTimelineItem').then(c => ({
    default: c.ProgressTimelineItem,
})));
export const ReportCreatedTimelineItem = lazy(() => import('./ReportCreatedTimelineItem/ReportCreatedTimelineItem').then(c => ({
    default: c.ReportCreatedTimelineItem,
})));
export const ReportDescriptionTimelineItem = lazy(() => import('./ReportDescriptionTimelineItem/ReportDescriptionTimelineItem').then(c => ({
    default: c.ReportDescriptionTimelineItem,
})));
export const TimelineMessageForm = lazy(() => import('./TimelineMessageForm/TimelineMessageForm').then(c => ({
    default: c.TimelineMessageForm,
})));
export const ConversationTimelineItem = lazy(() => import('./ConversationTimelineItem/ConversationTimelineItem').then(c => ({
    default: c.ConversationTimelineItem,
})));
export * from './TimelineItem.types';
